<template>
  <div class="pc-note__sidebar-pannel">
    <slot name="header"/>
    <div class="pc-note__sidebar-pannel-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__sidebar-pannel {
  height: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.pc-note__sidebar-pannel-body {
  overflow: auto;
}

</style>
